<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="10">
          <el-form-item label="序号" prop="seqno">
            <el-input
              v-model="formData.seqno"
              disabled
              clearable
              size="mini"
              placeholder="暂无数据"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="登记项名称" prop="detailItemName">
            <el-input
              v-model="formData.detailItemName"
              disabled
              clearable
              size="mini"
              placeholder="暂无数据"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :offset="4"></el-col>
        <el-col :span="20">
          <el-form-item label="登记项值" prop="detailItemValue">
            <el-input type="textarea" :rows="2"
              v-model="formData.detailItemValue"
              :disabled="disabled"
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :offset="4"></el-col>
        <el-col :span="20">
          <el-form-item label="备注信息" prop="detailItemRemark">
            <el-input type="textarea" :rows="2" v-model="formData.detailItemRemark" :disabled="disabled" clearable size="mini"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
// import { updateApi } from '@api/projectManager/infoSample'
export default {
  props: {
  },
  data () {
    return {
      disabled: false,
      formData: {
        prjInfoSampleCode: '',
        prjCode: '',
        seqno: '',
        detailItemName: '',
        detailItemValue: '',
        detailItemRemark: ''
      },
      rules: {
        detailItemValue: [
          { required: true, message: '请输入登记项', trigger: 'blur' },
          { max: 500, message: '长度在500个字符以内', trigger: 'blur' }
        ],
        detailItemRemark: [
          { required: false, message: '请输入备注信息', trigger: 'blur' },
          { max: 500, message: '长度在500个字符以内', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 加载表单数据（新增，编辑，详情）
    fromLoad (ref, val = { }) {
      this.init()
      if (ref !== 'add') {
        this.formData = val
        // 控制组件不可编辑
        if (ref === 'detail') {
          this.disabled = true
        }
      }
    },
    // 保存数据
    save () {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.sampleUpdateApi(this.formData)
            .then(res => {
              this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success'
              })
              // 通知父组件保存成功
              this.$emit('success')
            })
        } else {
          return false
        }
      })
    },
    // 初始化表单数据
    init () {
      this.disabled = false
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    }
  }
}
</script>
